module.exports = __webpack_public_path__ + "media/images/strategic-partners/ringrx-92e6ebec07c6425ac5d6154e5f9e5db1.jpeg";